
import AppMobileFullScreenContaziner from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import { ExtraFieldNamesConfig, EXTRA_FIELD_TYPES, ExtraFieldType } from "../../../models/dossier-configs/extra-field-names-config";
import { ExtraFieldNamesConfigs } from "../../../models/dossier-configs/extra-field-names-configs";
import { DossierConfigService } from "../../../services/dossier-config-service";
import AppExtraFieldGroup from "@/components/settings-default/ExtraFieldGroup.vue";
import { ExtraFieldsType, getExtraFieldCount } from "@/utils/models/extra-fields";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { EXTRA_FIELD_TAB_TYPES } from "@/components/settings-default/ExtraFieldBaseOptions.vue";
import { CustomerService, ProspectService, SupplierService } from "@/services";
import { ContactService } from "@/utils/services/contact-service";
import { ProductService, ProductServiceClass } from "@/services/product-service";
import { SaleService, SaleServiceClass } from "@/services/sale-service";
import { PurchaseService, PurchaseServiceClass } from "@/services/purchase-service";

export default Vue.extend({
	provide(){
		return {
			extraFieldTabs: ():ExtraFieldTabConfig[] => this.settings.Tabs
		};
	},
	data() {
		return {
			settings: DossierConfigService.getExtraFieldNamesConfigs().ClientNames,
			toEditIndex: 0,
		};
	},
	props: {
		editKey: {
			type: String,
			required: true
		}
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/extra-field-names", value: this.$ct("extra-fields")},
				{value: this.$ct(this.editKey || "")},
			] as IBreadCrumb[];
		},
		supportsTabs():boolean {
			return EXTRA_FIELD_TAB_TYPES.indexOf(this.fieldsType) != -1;
		},
		supportsDefaultValues():boolean {
			return ["ClientNames", "SupplierNames", "ProspectNames", "ProductNames", "SaleNames", "PurchaseNames"].indexOf(this.editKey) != -1;
		},
		fieldTypes():ExtraFieldType[] {
			return EXTRA_FIELD_TYPES;
		},
		usedCount():number {
			return EXTRA_FIELD_TYPES.reduce((total, type)=>total + this.settings.getUsedIndexes(type).length, 0);
		},
		freeCount():number {
			return EXTRA_FIELD_TYPES.length * getExtraFieldCount() - this.usedCount;
		},
		title():string {
			// Get the translation for the editKey and convert it to lowercase
			const translatedKey = this.$ct(this.editKey).toString().toLowerCase();
			return this.$ct("extra-fields-of", {prop: translatedKey}).toString();
		},
		dropdownItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("set-default-values"),
					value: this.setDefaultValues.bind(this)
				}
			];
		},
		fieldsType():ExtraFieldsType {
			if (this.editKey == "SupplierNames") {
				return ExtraFieldsType.CONTACT;
			}else if(this.editKey == "ProspectNames"){
				return ExtraFieldsType.CONTACT;
			}else if(this.editKey == "ClientNames"){
				return ExtraFieldsType.CONTACT;
			}else if (this.editKey == "ProductNames"){
				return ExtraFieldsType.PRODUCT;
			}else if (this.editKey == "SaleNames"){
				return ExtraFieldsType.SALE;
			}else if (this.editKey == "SaleRowNames"){
				return ExtraFieldsType.SALE_ROWS;
			} else if (this.editKey == "PurchaseNames"){
				return ExtraFieldsType.PURCHASE;
			}else if (this.editKey == "CarNames"){
				return ExtraFieldsType.CAR;
			}else if (this.editKey == "CrmNames"){
				return ExtraFieldsType.CRM;
			}else if (this.editKey == "LedgerAccountNames") {
				return ExtraFieldsType.LEDGER_ACCOUNT;
			}else if (this.editKey == "ProjectNames") {
				return ExtraFieldsType.PROJECT;
			}else if (this.editKey == "BankNames") {
				return ExtraFieldsType.BANK;
			}
			const errorMsg = `Unknown editKey: ${this.editKey}`;
			this.$wf.notify(errorMsg, "danger", 3000, "exclamation-triangle");
			throw new Error(errorMsg);
		}
	},
	methods: {
		tabFieldCount(tabId:string):string {
			let count = this.settings.getFieldsForTab(tabId).length;
			if (count == 0) return this.$ct("tab-empty").toString();
			return this.$ctc("tab-field-count", count, {count}).toString();
		},
		cancel(){
			this.$router.go(-1);
		},
		addTab(){
			let tab = new ExtraFieldTabConfig();
			this.settings.Tabs.push(tab);
			this.$nextTick(()=>{
				let refs = this.$refs["tab" + tab.ID] as HTMLInputElement[] | undefined;
				if (refs && refs[0]) refs[0].focus();
			});
		},
		async removeTab(index:number){
			let tab = this.settings.Tabs[index];
			if (!tab) return;
			let fields = this.settings.getFieldsForTab(tab.ID);
			if (fields.length > 0) {
				let message = this.$ct("remove-extra-field-tab-confirm", {count: fields.length});
				let confirm = await this.$wf.confirm(message, this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
				if (!confirm) return;
				for (let field of fields) {
					this.settings.getFieldConfig(field).TabID = "";
				}
			}
			this.settings.Tabs.splice(index, 1);
		},
		async save() {
			let settings = DossierConfigService.getExtraFieldNamesConfigs();
			(settings as any)[this.editKey as keyof ExtraFieldNamesConfig] = this.settings as any;
			await DossierConfigService.saveExtraFieldNamesConfigs(settings);
			this.$router.go(-1);
		},
		async setDefaultValues(){
			let service:ContactService | ProductServiceClass | SaleServiceClass | PurchaseServiceClass = CustomerService;
			if (this.editKey == "SupplierNames") {
				service = SupplierService;
			}else if(this.editKey == "ProspectNames"){
				service = ProspectService;
			}else if (this.editKey == "ProductNames"){
				service = ProductService;
			}else if (this.editKey == "SaleNames"){
				service = SaleService;
			}else if (this.editKey == "PurchaseNames"){
				service = PurchaseService;
			}else {
				throw new Error("Unimplemented");
			}
			await service.setDefaultExtraFieldValues();
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		}
	},
	mounted() {
		this.settings = DossierConfigService.getExtraFieldNamesConfigs()[this.editKey as keyof ExtraFieldNamesConfigs] as ExtraFieldNamesConfig;
		if(!this.settings.NumOrder.length){
			this.save();
			this.settings = DossierConfigService.getExtraFieldNamesConfigs()[this.editKey as keyof ExtraFieldNamesConfigs] as ExtraFieldNamesConfig;
		}
	},
	components: {
		AppMobileFullScreenContaziner,
		AppExtraFieldGroup,
		AppToolbar,
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
